/**
 * Checks if an Expires header value has expired
 * @param expiresHeader - The value of the Expires header
 * @returns boolean - true if expired, false if not expired
 */
export function isExpired(expiresHeader: string): boolean {
  // Parse the expires header into a Date object
  const expiresDate = new Date(expiresHeader);

  // Check if the parsed date is valid
  if (isNaN(expiresDate.getTime())) {
    throw new Error('Invalid Expires header format');
  }

  // Compare with current time
  const now = new Date();
  return expiresDate < now;
}

/**
 * Formats a date into a human-readable string
 * @param date - Date to format
 * @returns string - Formatted date string
 */
export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  }).format(date);
}